import React, { useContext } from "react";
import { DataContext } from "../../contexts/DataContext";
import OfficialsEdit from "../Officials/OfficialEdit";
import SavePanel from "../UI/Form/SavePanel";
import Modal from "../UI/Modal/Modal";
import Panel from "../UI/Panel/Panel";
import PanelContent from "../UI/Panel/PanelContent";
import PanelTitle from "../UI/Panel/PanelTitle";

export default function OfficialsEditor({
  officials,
  onSave,
  onCancel,
  selectOfficials,
}) {
  const { updateOfficial, deleteOfficial } = useContext(DataContext);

  return (
    <Modal
      style={{ width: "50%" }}
      show={officials}
      onCancel={() => {
        selectOfficials();
        onCancel();
      }}
    >
      {officials && (
        <Panel style={{ marginTop: "-10%" }}>
          <PanelTitle title={"Officials Edit"}>
            <div>{officials._id}</div>
          </PanelTitle>
          <PanelContent>
            <OfficialsEdit
              officials={officials}
              onChange={(s) => {
                selectOfficials(s);
              }}
            />
          </PanelContent>

          <SavePanel
            showDelete={officials._id}
            onDelete={() => {
              deleteOfficial({ data: officials }).then(() => {
                selectOfficials();
                onSave();
              });
            }}
            onSave={() => {
              updateOfficial({ data: officials }).then(() => {
                selectOfficials();
                onSave();
              });
            }}
            onCancel={() => {
              selectOfficials();
              onCancel();
            }}
          ></SavePanel>
        </Panel>
      )}
    </Modal>
  );
}
